import getCookieByName from '../helpers/getCookieByName'

function parsePredefinedCookieData({ state, output }) {
  let busCookie = getCookieByName('busPredefined')
  if (busCookie) {
    try {
      let predefined = JSON.parse(decodeURIComponent(busCookie))
      predefined.forEach(data => {
        const { hidden, hideForAdmins, value, condition } = data
        state.set(
          `client.busPredefined.${data.type}.${data.field || data.key}`,
          {
            hidden,
            value,
            condition,
            hideForAdmins
          }
        )
      })
      output.cookieExist()
    } catch (e) {
      output.cookieParseError()
    }
  } else {
    output.cookieDoesNotExist()
  }
}

parsePredefinedCookieData.outputs = [
  'cookieExist',
  'cookieDoesNotExist',
  'cookieParseError'
]
export default parsePredefinedCookieData



// WEBPACK FOOTER //
// ./src/modules/app/actions/parsePredefinedCookieData.js